module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhnplayart.19756c6ba1c848cdece6ab1f77b34b97.png";